import React, { useState,useCallback, useEffect, useMemo, Suspense } from 'react';
import { GridContainer, Grid } from '../../shared/grid';
import './Download.scss';
import { Formik, Form } from 'formik';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import CheckIcon from '@mui/icons-material/Check';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography,Autocomplete, Chip, TextField, Switch } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ONEDAY, ONEMIN, ONESEC, ValidCharacters, errorResponse, validateCharacters, isValidDate, fieldSampleAreaEditor } from '../../store/common';
import { useStoreContext } from '../../store/context';
import { FuelModels, alertMessages } from '../../constants';
import { Modal } from 'rsuite';
import moment from "moment-timezone"
import Button from '@mui/material/Button';
import { validationSchema } from './formSchema';
import { Station } from '../../types';
import { useAddAlert, useAllStations, useUser } from '../../store/actions';
import LoadingSpinner from '../../shared/loading/loading';
import localforage from 'localforage';
import axios from 'axios';
import { Weather } from '../download/weather';
import { StationInformation } from './stationInfo';
import { getSiteKeysForSearch } from 'src/apis/getFuelSampleCalls';

import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SiteMetadata, VirtualizedListBoxSite } from './siteMetadata';
import { getStations } from 'src/apis/getWeatherCalls';
import { FireDanger } from '../download/FireDanger';

import dayjs from "dayjs";
import { ROUTE_PATHS } from 'src/routes';
import { getAccessTokenCookie } from 'src/shared/Login';
type ScrollCtxValue ={
    scrollTopRef: React.MutableRefObject<number>;
    restoreToken: number;
};

const ScrollCtx = React.createContext<ScrollCtxValue | null>(null);
const today = () => dayjs().startOf("day");
const Browse = React.lazy(()=> import('src/features/field-sample/FuelTypes/FuelTypesBrowse'))


export const transformIds = (data:any) =>{
	const stationsIds:string[] =[];
	data.map((station:any)=>{
		stationsIds.push(station.station_id.toString());
		return station;
	});
	return stationsIds;
};

export const Download: React.FC = () =>{
  const todayNum = Date.now();
  const allSiteSelect =  useMemo(()=>({site_id: -1,site_name: "Select All", site_key:"Select All", display_key:'Select All'}),[]);

	const [state,dispatch] = useStoreContext();
  const setUser = useUser(dispatch);
  const [token, setToken] = useState<string|null>(null);

  const [currSelectedStations, setCurrSelectedStations] = useState<any[]>([]);
  const [currSites, setCurrSites] = useState<any[]>([]);
	const allStoredStations = useAllStations(dispatch);
	const addAlert = useAddAlert(dispatch);
  const [valsFromSearch, setValsFromSearch] = useState<any[]>([]);
  const [sitesSearched, setSitesSearched] = useState<any[]>([]);
  const [startHrClicked, setStartHrClicked] =useState(false);
  const [endHrClicked, setEndHrClicked] =useState(false);
  const [openMaxFileSize, setOpenMaxFileSize] = React.useState(false);
  const handleOpenMaxFileSize = () => setOpenMaxFileSize(true);
  const handleCloseMaxFileSize = () => setOpenMaxFileSize(false);
  const [loading, setLoading] = useState(false);
  const [allSites, setAllSites] =useState<any[]>([allSiteSelect]);
  const [sitesFiltered, setSitesFiltered] =useState<any[]>([]);
  const [selectedAll, setSelectedAll] = useState<boolean>(false);

  const [errorDate, setErrorDate] = useState('');
  const [linkGenerated, setLinkGenerated] = useState<boolean>(false);
  const [shortURL, setShortURL] = useState('');
  const [longURL, setLongURL] = useState('');
  const [downloadFuelTypes, setDownloadFuelTypes] = useState<any[]|undefined>([]);
  const [downloadCategory, setDownloadCategory] = useState<string>('All');
  const [downloadSubCategory, setDownloadSubCategory] = useState<string>('All');
  const [downloadMethod, setDownloadMethod] = useState<string>('All');
  const [fieldSampleHasRows, setFieldSampleHasRows] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(moment(moment().valueOf()-(30*ONEDAY)).set({hour:0,minute:0,second:0,millisecond:0}).utc().toDate());
  const [endDate, setEndDate] = useState<any>(moment().set({hour:23,minute:59,second:59,millisecond:0}).utc().toDate());
  const [errorStartDate, setErrorStartDate] = useState<string|null>(null);
  const [errorEndDate, setErrorEndDate] = useState<string|null>(null);
  const [includeArchivedSamples, setIncludeArchivedSamples] = useState<boolean>(false);

  const [fuelModels, setFuelModels] = useState<any[]>(['Y'])
  const [presetSelected, setPresetSelected] = useState(false);
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [noRestrictedStations, setNoRestrictedStations] = useState<any[]>([]);

  const [stationsForSearch, setStationsForSearch] = useState<any[]>([]);

  const scrollTopRef = React.useRef(0);
  const [restoreToken, setRestoreToken] = useState(0);
  const [stationFailCount, setStationFailCount] = useState<number>(0)

  const handlePresetSelected = (isPresetSelected: boolean) => {
    setPresetSelected(isPresetSelected);
    setEndDate(moment().add(6, 'days').utc().toDate())
  };

  const checkQueueTrigger = useCallback((values: any, type: string) => {
    const start = moment(values.startDate);
    const end = moment(values.endDate);

    const dayCount = presetSelected === true ? 12 : Math.abs(start.diff(end, 'days'));
    const stationCount = currSelectedStations.length;

    const isFireDanger = values.dataSubject.toLowerCase() === 'firedanger';
    const isHourly = type.includes('hourly');

    // ---- FIRE DANGER ----
    if (isFireDanger) {
      const fuelCount = values.fuelModels.split(',').length;

      if (isHourly) {
        // -------------------------
        // MULTI FUEL
        // -------------------------
        if (fuelCount > 1) {
          // only normal download case
          if (dayCount <= 12 && stationCount <= 20) {
            return false;
          }

          // everything else queues
          return true;
        }

        // -------------------------
        // SINGLE FUEL
        // -------------------------
        if (fuelCount === 1) {
          if (stationCount > 100) return true;

          if (stationCount > 10 && dayCount > 365) return true;

          if (dayCount > 365 * 3) return true;

          return false;
        }
      }

      // ---- FIRE DANGER DAILY ----
      return stationCount > 50 || (stationCount > 10 && dayCount > 365);
    } else {
      // ---- Wx Rules----
      if (isHourly) { 
        if (stationCount > 50) return true; 
        if (stationCount > 10 && dayCount > 365) return true; 
        if (stationCount > 1 && dayCount >= 365 * 10) return true; 
        return false; 
      } 
      // daily 
      return stationCount > 50 || (stationCount > 10 && dayCount > 365); 

    }
  }, [currSelectedStations.length, presetSelected]);
  
  
  const noDownloadCheck = useCallback((values: any, type: string, fuelModels?:string) =>{
    if(values.dataSubject.includes('weather')){
      if(((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 300) && type.includes('hourly') && values.dataFormat!=='zip'))
      {
        return true;
      } 
      else if(((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 50) && type.includes('hourly') && values.dataFormat==='zip'))
      {
        return true;
      } 
      else{
        return false;
      }
    }
    if(values.dataSubject.includes('FireDanger')){
      if(values.dataFormat==='zip') {
        if( values.fuelModels?.length===1 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 50) && type.includes('hourly')))
        {
          return true;
        }
        else if(values.fuelModels?.length===3 &&((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 25) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===5 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 16) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===7 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 13) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===9 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 10) && type.includes('hourly'))){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        if( values.fuelModels?.length===1 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 300) && type.includes('hourly')))
        {
          return true;
        }
        else if(values.fuelModels?.length===3 &&((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 150) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===5 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 100) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===7 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 75) && type.includes('hourly'))){
          return true;
        }
        else if(values.fuelModels?.length===9 && ((Math.abs(moment(values.startDate).diff(moment(values.endDate), 'years')) >= (20 )) &&( currSelectedStations.length > 60) && type.includes('hourly'))){
          return true;
        }
        else{
          return false;
        }
      }
    }
  },[currSelectedStations.length]);

  const stationCallback = useCallback((all:boolean, counter: number) =>{
    if(all){
      (async()=>{
        try{
          const varRequest = {
            returnAll: true,				
          };
          const response: any = await getStations(varRequest, addAlert, state?.user);
          if(response){
            const stations = response.stations.sort(function(a:any, b:any) {
              return a.search_name.localeCompare(b.search_name);
            })
            allStoredStations(stations);
            setStationsForSearch(stations)
            setStationFailCount(0)
          }
        }
        catch(error){
          setStationFailCount(counter+1)
          console.log('error', error)
        }
      })();
    }
    else{
      		(async()=>{
			try{
				const varRequest = {
          returnAll: true,
          // stationMetadataVisible: 'TRUE',
          weatherDailyVisible: 'ALL',
          nfdrsDailyVisible:'ALL', 
          weatherHourlyVisible: 'ALL', 
          nfdrsHourlyVisible: 'ALL', 
          weatherDailyDownload: 'ALL', 
          weatherHourlyDownload: 'TRUE', 
          nfdrsDailyDownload: 'ALL', 
          nfdrsHourlyDownload: 'ALL', 
          produceNfdrs: 'ALL', 
          ingestObservation: 'ALL',			
				};
				const response: any = await getStations(varRequest, addAlert, state?.user);
				if(response){
          const stations = response.stations.sort(function(a:any, b:any) {
            return a.search_name.localeCompare(b.search_name);
          })
          setNoRestrictedStations(stations);
          setStationsForSearch(stations);
          setStationFailCount(0)
				}
			}
			catch(error){
        console.log('error', error)
        setStationFailCount(counter+1)
			}
		})();
    }
	},[addAlert, allStoredStations, state?.user]);

  const getSitesKey = useCallback(()=>{
    (async () => {
      try {
        const siteKeys:any = await getSiteKeysForSearch(null, addAlert);
        siteKeys.unshift(allSiteSelect)
        setAllSites(siteKeys);
      }
      catch (error) {
        errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
      }
    })();
  },[addAlert, allSiteSelect]);

  /*if all stations have not been called, all it*/
  useEffect(()=>{
    if(state.all_stations){
      if(state.all_stations.length<1){
      localforage.getItem('allStations').then(async function(stations){
        let allStations = stations as Station[];
        if(!allStations){
          stationCallback(true, stationFailCount);
        }
        else{
          setStationsForSearch(allStations)
          allStoredStations(allStations);
        }
      })
    }
  }
  },[currSelectedStations, state.all_stations, stationCallback, allStoredStations, setStationsForSearch, stationFailCount]);

  /*restricted mesonets of hourly not visible will be filtered out*/
  useEffect(()=>{
    if(noRestrictedStations?.length<1){
      stationCallback(false, stationFailCount);
    }
  },[stationCallback, noRestrictedStations?.length, stationFailCount]);

  useEffect(()=>{
    if(stationFailCount>0 && stationFailCount<4){
      stationCallback(false, stationFailCount);
    }
  },[stationFailCount, stationCallback])

  useEffect(()=>{
    if(allSites.length<=1){
      getSitesKey();
    }
  },[allSites, getSitesKey]);

  const handleClickHour =()=>{
    setStartHrClicked(!startHrClicked);
  }
  const handleEndHourClicked =()=>{
    setEndHrClicked(!endHrClicked);
  }

  useEffect(()=>{
    if(state.userTokens && token) {
      /** If the Token is refreshed this will set the @param token equal to updated value */
      setToken(state.userTokens.accessToken);
    }
    else if(localStorage.getItem('user') && state.userTokens && !token){
      /** find access token and set to send to bearer */
      const parsedSession = JSON.parse(localStorage.getItem('user')??'');
      setUser(parsedSession.userInfo);
      setToken(state.userTokens.accessToken);
    }
  },[state.userTokens, state.user, token, setUser, setToken]);

  const handleSubmit= (values:any)=>{
    const cookieToken = getAccessTokenCookie(`accessToken`);
    let jobIdsStrings = localStorage.getItem('dlJobs');
    let newJobIdsArrayFromStorage = jobIdsStrings? JSON.parse(jobIdsStrings) : [];
    let dlTimeStrings = localStorage.getItem('dlReqTimes');
    let dlTimesArray = dlTimeStrings? JSON.parse(dlTimeStrings) : [];
      if(values.dataSubject.includes('stationMetadata')){
        (async() =>{
          try{
            setLoading(true);  
            const url = `${process.env.REACT_APP_API}/download-stationmeta`;
            let requestBodyForPost:any= {
                  stations: values.dataSelectedStations,
                  dataformat:values.dataFormat
                };
            await axios.post(url, requestBodyForPost, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${cookieToken === null || cookieToken === undefined ? '' : cookieToken}`
              },
              responseType: 'blob'
            })
            .then(async function(response:any){
                setLoading(false);
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', 'StationMetaData.csv'); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);  
            })
            .catch(function (error:any) {
              setLoading(false);
              addAlert({
                id:'',
                message: alertMessages.exportDownloadData,
                type:'error-info',
                icon:'fa-exclamation-triangle'
              })
              console.log(error);
            });
          }
          catch(error){
            setLoading(false);
            errorResponse(error, addAlert, alertMessages.exportDownloadData);
            console.log(error);
          }
        })()
      } else if(values.dataSubject.includes('siteMetadata')) {
        (async() =>{
          try{
            setLoading(true);    
            const fuelDownloadURL = globalThis.location.host.includes('localhost') ? 
              `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`.split('apis/graphql', 1)[0].concat('siteMetadataDownload/download?') :
              `${process.env.REACT_APP_GRAPHQL_URL}`.split('api/climatology/graphql', 1)[0].concat('fuelmodel/siteMetadataDownload/download?');
            
            const siteIds = selectedAll ? `` : `siteIds=${sitesSearched.map(site => site.site_id).join(',')}`;

            const url =  `${fuelDownloadURL}${siteIds}`;        
            await axios.get(url, {responseType: 'blob'})
            .then(async function(response:any){
              setLoading(false);
              const href = URL.createObjectURL(response.data);
              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', 'Site_Metadata.csv'); 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(href);                
            })
            .catch(function (error:any) {
              setLoading(false);
              addAlert({
                id:'',
                message: alertMessages.exportDownloadData,
                type:'error-info',
                icon:'fa-exclamation-triangle'
              })
              console.log(error);
            });
          }
          catch(error){
            setLoading(false);
            errorResponse(error, addAlert, alertMessages.exportDownloadData);
            console.log(error);
          }
        })()
      } else if(values.dataSubject.includes('fieldSample')) {
        (async() =>{
          try{
            setLoading(true);    
            const start = moment.utc(values.startDate +' ' +values.startHour+":00:00").toISOString();
            const end = moment.utc(values.endDate +' ' +values.endHour+":00:00").toISOString();
            const fuelDownloadURL = globalThis.location.host.includes('localhost') ? 
              `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`.split('apis/graphql', 1)[0].concat('sample/download?') :
              `${process.env.REACT_APP_GRAPHQL_URL}`.split('api/climatology/graphql', 1)[0].concat('fuelmodel/sample/download?');
            
            const siteIds = selectedAll ? 'All' : sitesSearched.map(site => site.site_id).join(',');
            const status = includeArchivedSamples ? 'All' : 'Submitted';
            const fuelIdList:any = [];
            downloadFuelTypes?.forEach(fuelType => {
              fuelIdList.push(fuelType.fuel_id);
            });

            const url =  `${fuelDownloadURL}returnAll=${values.returnAll}&responseFormat=csv&siteId=${siteIds}&sampleId=&startDate=${start}&endDate=${end}&filterByFuelId=${fuelIdList.join(',')}&filterByStatus=${status}&filterByCategory=${downloadCategory}&filterBySubCategory=${downloadSubCategory}&filterByMethod=${downloadMethod}&sortBy=${values.orderBy}&sortOrder=${values.order}`;        
            await axios.get(url, {responseType: 'blob'})
            .then(async function(response:any){
              setLoading(false);
              const href = URL.createObjectURL(response.data);
              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', 'fieldSample.csv'); 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(href);                
            })
            .catch(function (error:any) {
              setLoading(false);
              addAlert({
                id:'',
                message: alertMessages.exportDownloadData,
                type:'error-info',
                icon:'fa-exclamation-triangle'
              })
              console.log(error);
            });
          }
          catch(error){
            setLoading(false);
            errorResponse(error, addAlert, alertMessages.exportDownloadData);
            console.log(error);
          }
        })()
      } else if(values.dataTimeIncrements.includes('hourly') && (values.dataSubject.includes('weather') || values.dataSubject.includes('FireDanger'))){
        (async() =>{
          try{
            const start = moment.utc(values.startDate +' ' +values.startHour+":00:00");
            const end = moment.utc(values.endDate +' ' +values.endHour+":00:00");
            setLoading(true);    
            const tz = values.timeZoneType==='utc'? 'UTC': 'LocalStationTime';

            const valuesFuelModels = values.fuelModels === 'V,W,X,Y,Z' ? '' : `&fuelModels=${values.fuelModels}`
            const dataset = values.dataSet ==='observationforecast'? 'all': values.dataSet
            let url = values.dataSubject === 'weather'? `${process.env.REACT_APP_API}/download-weather`: `${process.env.REACT_APP_API}/download-nfdr`;
            let requestBodyForPost:any=null;

            if(presetSelected){
              if(values.dataSubject === 'weather' && !(checkQueueTrigger(values, 'hourly'))){
                url= url+`?stationIds=${values.dataSelectedStations}&presetDate=-5Days7Days&dataset=${dataset}&dataFormat=${values.dataFormat}`;
              }
              if(values.dataSubject === 'weather' && (checkQueueTrigger(values, 'hourly'))){
                requestBodyForPost = {
                  stationIds: values.dataSelectedStations,
                  presetDate: '-5Days7Days',
                  dataFormat:values.dataFormat,
                  dataset:dataset,
                };
              }
              if(values.dataSubject !== 'weather' && !(checkQueueTrigger(values, 'hourly'))){
                url= url+`?stationIds=${values.dataSelectedStations}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}&dataset=${dataset}${valuesFuelModels}&dateTimeFormat=${tz}`
              }
              if(values.dataSubject !== 'weather' && (checkQueueTrigger(values, 'hourly'))){
                requestBodyForPost = {
                  stationIds: values.dataSelectedStations,
                  presetDate: '-5Days7Days',
                  dataFormat:values.dataFormat,
                  dataset:dataset,
                  fuelModels:values.fuelModels === 'V,W,X,Y,Z' ? '' : `${values.fuelModels}`,
                  dateTimeFormat:tz,
                };
              }
            }
            else{
              if(values.dataSubject === 'weather' && !(checkQueueTrigger(values, 'hourly'))){
                url=`${process.env.REACT_APP_API}/download-weather?stationIds=${values.dataSelectedStations}&startDate=${moment.utc(start.valueOf()- 30*ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]')}&endDate=${moment.utc(end.valueOf()+ (30*ONEMIN) -ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]')}&dataset=${dataset}&dataFormat=${values.dataFormat}`;
              }
              if(values.dataSubject === 'weather' && (checkQueueTrigger(values, 'hourly'))){
                requestBodyForPost = {
                  stationIds: values.dataSelectedStations,
                  endDate:moment.utc(end.valueOf()+ (30*ONEMIN) -ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                  startDate:moment.utc(start.valueOf()- 30*ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                  dataFormat:values.dataFormat,
                  dataset:dataset,
                };
              }
              if(values.dataSubject !== 'weather' && !(checkQueueTrigger(values, 'hourly'))){
                url=`${process.env.REACT_APP_API}/download-nfdr?stationIds=${values.dataSelectedStations}&endDate=${moment.utc(end.valueOf()+ (30*ONEMIN) -ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]')}&startDate=${moment.utc(start.valueOf()- 30*ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]')}&dataFormat=${values.dataFormat}&dataset=${dataset}${valuesFuelModels}&dateTimeFormat=${tz}`;
              }

              if(values.dataSubject !== 'weather' && (checkQueueTrigger(values, 'hourly'))){
                requestBodyForPost = {
                  stationIds: values.dataSelectedStations,
                  endDate:moment.utc(end.valueOf()+ (30*ONEMIN) -ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                  startDate:moment.utc(start.valueOf()- 30*ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                  dataFormat:values.dataFormat,
                  dataset:dataset,
                  fuelModels:values.fuelModels === 'V,W,X,Y,Z' ? '' : `${values.fuelModels}`,
                  dateTimeFormat:tz,
                };
              }

            }
            if(checkQueueTrigger(values, 'hourly')){
              //if over 1 year and over 7 stations then do a post
              await axios.post(url, requestBodyForPost, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${cookieToken===null|| cookieToken===undefined? '': cookieToken}`
                },
                responseType: 'json'
              })
              .then(async function(response:any){
                setLoading(false);
                if(response.data.jobId){
                  handleOpenMaxFileSize();
                  if(!cookieToken){
                    newJobIdsArrayFromStorage?.push({jobId: response.data.jobId, id: response.data.id})
                    dlTimesArray?.push(moment().format('YYYY-MM-DD HH:mm:ss'))
                    localStorage.setItem("dlJobs", JSON.stringify(newJobIdsArrayFromStorage));
                    localStorage.setItem("dlReqTimes", JSON.stringify(dlTimesArray));
                  }
                }
              })
              .catch(function (error:any) {
                setLoading(false);
                addAlert({
                  id:'',
                  message: alertMessages.exportDownloadData,
                  type:'error-info',
                  icon:'fa-exclamation-triangle'
                })
                console.log(error);
              });

            }
            else { 
              //blob and get call
              await axios.get(url, {
                headers: {
                  'Authorization': `Bearer ${cookieToken === null || cookieToken === undefined ? '' : cookieToken}`
                },
                responseType: 'blob'
              })
                .then(async function (response: any) {
                  setLoading(false);

                  let fileName = 'exportData'; //fallback placeholder
                  const contentDisposition = response.headers['content-disposition'];

                  if(contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+?)"?$/);
                    if(match?.[1]) {
                      fileName = match[1];
                    }
                  }

                  if (response.data.jobId) {
                    handleOpenMaxFileSize();
                    if (!cookieToken) {
                      newJobIdsArrayFromStorage?.push({ jobId: response.data.jobId, id: response.data.id })
                      dlTimesArray?.push(moment().format('YYYY-MM-DD HH:mm:ss'))
                      localStorage.setItem("dlJobs", JSON.stringify(newJobIdsArrayFromStorage));
                      localStorage.setItem("dlReqTimes", JSON.stringify(dlTimesArray));
                    }
                  }
                  else {
                    const href = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                  }
                })
                .catch(function (error: any) {
                  setLoading(false);
                  addAlert({
                    id: '',
                    message: alertMessages.exportDownloadData,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                  })
                  console.log(error);
                });
            }
          }
          catch(error){
            setLoading(false);
            errorResponse(error, addAlert, alertMessages.exportDownloadData);

            console.log(error);
          }
        })()
      } else if(values.dataTimeIncrements.includes('daily') && (values.dataSubject.includes('weather') || values.dataSubject.includes('FireDanger'))){
        (async() =>{
          try{
            setLoading(true);              
            const valuesFuelModels = values.fuelModels === 'V,W,X,Y,Z' ? '' : `&fuelModels=${values.fuelModels}`
            const dataset = values.dataSet ==='observationforecast'? 'all': values.dataSet
           
            let url = values.dataSubject === 'weather'? 
            (`${process.env.REACT_APP_API}/download-wx-daily-summary/`):
            (values.averageFireDanger? 
              (`${process.env.REACT_APP_API}/download-nfdr-daily-avg/`)
              :(`${process.env.REACT_APP_API}/download-nfdr-daily-summary/`)
            );
            let requestBody: any=null;
            
            if (presetSelected) {
              if (values.dataSubject === 'weather') {
                if (checkQueueTrigger(values,'daily')) {
                  requestBody = {
                    stationIds: values.dataSelectedStations,
                    presetDate: '-5Days7Days',
                    dataFormat: values.dataFormat,
                    dataset: dataset,
                  };

                }
                else {
                  url = url + `?stationIds=${values.dataSelectedStations}&dataset=${dataset}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}`
                }
              }
              else {
                if (checkQueueTrigger(values,'daily')) {
                  requestBody = {
                    stationIds: values.dataSelectedStations,
                    presetDate: '-5Days7Days',
                    dataFormat: values.dataFormat,
                    dataset: dataset,
                    fuelModels: values.fuelModels === 'V,W,X,Y,Z' ? '' : `${values.fuelModels}`,

                  };
                }
                else {
                  url = url + `?dataset=${dataset}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`
                }
              }
            }
            
            else{
              if(values.dataSubject === 'weather'){
                if (checkQueueTrigger(values,'daily')) {
                  requestBody = {
                    stationIds: values.dataSelectedStations,
                    endDate: values.endDate,
                    startDate: values.startDate,
                    dataFormat: values.dataFormat,
                    dataset: dataset,
                  };

                }
                else {
                  url=url+`?stationIds=${values.dataSelectedStations}&dataset=${dataset}&startDate=${values.startDate}&endDate=${values.endDate}&dataFormat=${values.dataFormat}`
                }
              }
              else{
                if (checkQueueTrigger(values,'daily')) {
                  requestBody = {
                    stationIds: values.dataSelectedStations,
                    endDate: values.endDate,
                    startDate: values.startDate,
                    dataFormat: values.dataFormat,
                    dataset: dataset,
                    fuelModels:values.fuelModels === 'V,W,X,Y,Z' ? '' : `${values.fuelModels}`,
                  };
                }
                else {
                  url= url+`?dataset=${dataset}&startDate=${values.startDate}&endDate=${values.endDate}&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`
                }

              }
            }
           
            if(checkQueueTrigger(values, 'daily')){
              //if over 1 year and over 7 stations then do a post
              await axios.post(url, requestBody, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${cookieToken===null|| cookieToken===undefined? '': cookieToken}`
                },
                responseType: 'json'
              })
              .then(async function(response:any){
                setLoading(false);
                if(response.data.jobId){
                  handleOpenMaxFileSize();
                  if(!cookieToken){
                    newJobIdsArrayFromStorage?.push({jobId: response.data.jobId, id: response.data.id})
                    dlTimesArray?.push(moment().format('YYYY-MM-DD HH:mm:ss'))
                    localStorage.setItem("dlJobs", JSON.stringify(newJobIdsArrayFromStorage));
                    localStorage.setItem("dlReqTimes", JSON.stringify(dlTimesArray));
                  }
                }
              })
              .catch(function (error:any) {
                setLoading(false);
                addAlert({
                  id:'',
                  message: alertMessages.exportDownloadData,
                  type:'error-info',
                  icon:'fa-exclamation-triangle'
                })
                console.log(error);
              });

            }
            else {
              //blob for when <=7 stations or less than <1
              await axios.get(url, {
                headers: {
                  'Authorization': `Bearer ${cookieToken === null || cookieToken === undefined ? '' : cookieToken}`
                },
                responseType: `blob`
              })
                .then(async function (response: any) {
                  setLoading(false);

                    let fileName = 'exportData'; //fallback placeholder
                    const contentDisposition = response.headers['content-disposition'];

                    if(contentDisposition) {
                      const match = contentDisposition.match(/filename="?(.+?)"?$/);
                      if(match?.[1]) {
                        fileName = match[1];
                      }
                    }

                  if (response.data.jobId) {
                    handleOpenMaxFileSize();
                    if (!cookieToken) {
                      newJobIdsArrayFromStorage?.push({ jobId: response.data.jobId, id: response.data.id })
                      dlTimesArray?.push(moment().format('YYYY-MM-DD HH:mm:ss'))
                      localStorage.setItem("dlJobs", JSON.stringify(newJobIdsArrayFromStorage));
                      localStorage.setItem("dlReqTimes", JSON.stringify(dlTimesArray));
                    }
                  }
                  else {
                    const href = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                  }
                })
                .catch(function (error: any) {
                  setLoading(false);
                  addAlert({
                    id: '',
                    message: alertMessages.exportDownloadData,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                  })
                  console.log(error);
                });
            }
          }
          catch(error){
            setLoading(false);
            errorResponse(error, addAlert, alertMessages.exportDownloadData);

            console.log(error);
          }
        })()
      }
  }
  const filterOptions =useCallback((options, state)=>{
    const inputValue = state.inputValue.trim().toLowerCase().split(/[ -]+/);
    const selectAllOpt = options[0];
    let filtered = options.filter((option:any)=>{
      const optionWords = option.display_key.trim().toLowerCase().split(/[ -]+/);

      return inputValue.every((word:string)=>{
        return optionWords.some((optionWord:string)=> optionWord.includes(word))
      })
    });
    
    if(filtered[0]!==selectAllOpt){
      filtered.unshift(selectAllOpt);
    }
    if(filtered.length!==sitesFiltered.length){
      setSitesFiltered(filtered);
    }
    return filtered
  },[sitesFiltered.length])

  return(
    <GridContainer className="margin-top-6">
      {loading && (<LoadingSpinner />)}
      <Grid row gap="md" className='page-heading'>
      <Grid
          desktop={{col:12}}
          className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
              <h1  className="font-sans-2xl text-bold">FEMS Data Download</h1>
          </Grid>
      </Grid>
      <Grid row gap="lg" desktop={{col:12}} className='page-blurb'>
        <div >Options to refine your download will appear as you make selections.<br></br>Changes to selections may impact your available options and selections.</div>
      </Grid>

      <Formik
        initialValues={
          { 
            returnAll: '',
            dataSubject: '', 
            dataSet: '', 
            dataFormat: '', 
            startHour:'00', 
            endHour:'23',
            startDate: '', 
            endDate:'',
            dataTimeIncrements: '', 
            dataSelectedStations: '', 
            timeZoneType: '', 
            stationTypes: '' ,
            sites: '',
            siteIds:'',
            fuels: '',
            status: '',
            orderBy: 'fuel_type',
            order: 'asc',
            fuelModels: 'Y',
            averageFireDanger: false,
        }}
        validateOnBlur={true}
        validateOnChange={true}
        validateOnMount={true}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values) }>
        {({
          values,
          errors,
          touched,
          handleSubmit,
          setFieldValue,
          handleBlur,
          isValid,
          setFieldTouched,
          
        }) => { 
            /*CLEARS stations*/
            const clearSelected = () => {
              setLinkGenerated(false);
              setCurrSelectedStations([]);
              setValsFromSearch([]);
              setFieldValue('dataSelectedStations', '');
              setAutocompleteKey(prev => prev + 1);
            };

            /*clears sites*/
            const clearSites = () => {
              setFieldSampleHasRows(false);
              setCurrSites([]);
              setSitesSearched([]);
              setFieldValue('sites', '');
              setFieldTouched('sites');
              setFieldValue('fuels','');
              setSelectedAll(false);
              setLinkGenerated(false);
            };

            /*method handleFuelModels is only available for nfdr*/
            const handleFuelModels = (event: SelectChangeEvent)=>{
              setLinkGenerated(false);
              setFieldTouched('fuelModels');
              const val:any = event.target.value;
              let fmodels = fuelModels;
              if(val.includes('All')){
                if (fmodels.includes('All')) {
                  const filterOutAll = val.filter(fm => fm !== 'All');
                  setFuelModels(filterOutAll);
                  setFieldValue('fuelModels', filterOutAll.join(','))

                }
                else {
                  const filtered = FuelModels.filter(fm => fm !== 'All')
                  setFuelModels(FuelModels);
                  setFieldValue('fuelModels', filtered.join(','))
                }
                
              }
              else{
                if(fmodels.includes('All')){
                  setFuelModels([])
                  setFieldValue('fuelModels', '')
                }else{
                  setFuelModels(val)
                  setFieldValue('fuelModels', val.join(','))
                }
              }
            }

          /*method handleFuelModels is only available for nfdr*/
          const deleteFuelModels = (value: any) => {
            setLinkGenerated(false);
            setFieldTouched('fuelModels');
            const removeSelection = fuelModels.filter((fm)=>fm!==value && fm!=='All')
            setFuelModels(removeSelection)
            setFieldValue('fuelModels', removeSelection.join(','))
          }


            /* clears data subject*/
            const setDataSubject =(event: SelectChangeEvent) =>{
              setLinkGenerated(false);
              setFieldTouched('dataSubject')
              setFieldValue('dataSubject', event.target.value);
              setFieldValue('timeZoneType', '');
              setFieldValue('averageFireDanger', false)
              clearSelected();
              clearSites();
              /*checks each time of dropdown value*/
              if(event.target.value===('stationMetadata')){
                setFieldValue('dataFormat', 'csv');
                setFieldValue('startDate', '')
                setFieldValue('endDate','')
              }
              else if(event.target.value==='fieldSample'){
                const startDate = moment(new Date(todayNum-30*ONEDAY)).format("YYYY-MM-DD");
                const endDate = moment(todayNum).format("YYYY-MM-DD");
                setFieldValue('startDate', startDate);
                setFieldValue('endDate', endDate);
                setFieldValue('dataFormat', 'csv');

              }
              else if(event.target.value==='siteMetadata'){
                setFieldValue('dataFormat', 'csv');
              }
              else{
                const startDate = moment(new Date(todayNum-14*ONEDAY)).format("YYYY-MM-DD");
                const endDate = moment(todayNum).format("YYYY-MM-DD");
                setFieldValue('startDate', startDate);
                setFieldValue('endDate', endDate);
                setFieldValue('dataFormat', '');
                setFieldTouched('dataFormat', false);
              }
              setFieldValue('dataSet', '');
              setFieldValue('dataSelectedStations', '')
              setFieldValue('sites', '')
              setCurrSites([]);
              setSitesSearched([]);
              setFieldValue('dataTimeIncrements', '')
              setFieldTouched('dataSelectedStations', false);
              setFieldTouched('sites', false);
              setFieldTouched('dataSet', false);
            };


            /* selects data set (used for weather & fireDanger -can select obs, forecast, or forecast and obs)*/
            const setDataSet = (event: SelectChangeEvent) => {
              setLinkGenerated(false);
              setFieldValue('dataSet', event.target.value);
              setFieldTouched('dataSet');
              setErrorDate('');
            
              let startDate, endDate;
            
              if (event.target.value === 'observation') {
                if(values.dataSubject === 'weather'){
                  startDate = moment(new Date(todayNum - 14 * ONEDAY)).format("YYYY-MM-DD");
                }else if(values.dataSubject === 'FireDanger'){
                  startDate = moment(new Date(todayNum - 30 * ONEDAY)).format("YYYY-MM-DD");
                }      
                endDate = moment(todayNum).format("YYYY-MM-DD");
              } else if (event.target.value === 'observationforecast') {
                startDate = moment(new Date(todayNum - 14 * ONEDAY)).format("YYYY-MM-DD");
                endDate = moment(new Date(todayNum + 7 * ONEDAY)).format("YYYY-MM-DD");
              } else if (event.target.value === 'forecast') {
                startDate = moment(new Date(todayNum)).format("YYYY-MM-DD");
                endDate = moment(new Date(todayNum + 7 * ONEDAY)).format("YYYY-MM-DD");
              }
            
              setFieldValue('startDate', startDate);
              setFieldValue('endDate', endDate);
            };

            /* data format selection*/
            const setDataFormat=(event: SelectChangeEvent)=>{
              setLinkGenerated(false);
              setFieldTouched('dataFormat');
              if(event.target.value==='fw13' || event.target.value==='fw21'){
                setFieldValue('timeZoneType', 'lst');
                setFieldValue('dataFormat', event.target.value);
              } 
              if(values.dataSubject==='weather'){
                if(values.dataTimeIncrements==='daily'){
                  setFieldValue('timeZoneType', 'lst')
                }
                if(values.dataTimeIncrements==='hourly'){
                  setFieldValue('timeZoneType', 'utc')
                }
                setFieldValue('dataFormat', event.target.value);
              }
              if(values.dataSubject==='FireDanger'){
                if(values.dataTimeIncrements==='daily'){
                  setFieldValue('timeZoneType', 'lst');
                  setFieldValue('dataFormat', event.target.value);
                }
                if(values.dataTimeIncrements==='hourly'){
                  if(event.target.value.includes('csv')){
                    setFieldValue('dataFormat', 'csv');
                  }
                  if(event.target.value.includes('zip')){
                    setFieldValue('dataFormat', 'zip')
                  }
                  if(event.target.value.includes('utc')){
                    setFieldValue('timeZoneType', 'utc')
                  }
                  if(event.target.value.includes('lst')){
                    setFieldValue('timeZoneType', 'lst')

                  }
                }
              }
            };

            const setDataIncrements=(e:SelectChangeEvent)=>{
              setLinkGenerated(false);
              setFieldTouched('dataTimeIncrements')
              setFieldValue('dataTimeIncrements', e.target.value)

              if(e.target.value ==='daily'){
                setFieldValue('timeZoneType', 'lst');
                setFieldValue('dataFormat', '');
                if(values.dataSubject==='weather'||values.dataSubject==='FireDanger'){
                  setStationsForSearch(state.all_stations)
                  clearSelected();
                }
              }
              if(e.target.value==='hourly' && values.dataSubject==='weather'){
                setFieldValue('timeZoneType', '');
                setFieldValue('dataFormat', '');
                setStationsForSearch(noRestrictedStations);
                clearSelected();
              }
              if(e.target.value==='hourly' && values.dataSubject==='FireDanger'){
                setFieldValue('timeZoneType', '');
                setFieldValue('dataFormat', '')
                setStationsForSearch(state.all_stations);
                clearSelected();
              }
            };
            const setEndHour=(e:SelectChangeEvent)=>{
              setLinkGenerated(false);
              setFieldValue('endHour', e.target.value);
            }
            const setStartHour=(e:SelectChangeEvent)=>{
              setLinkGenerated(false);
              setFieldValue('startHour', e.target.value);
            }
            const handleSearch=(e:React.SyntheticEvent<Element, Event>, val: any)=>{
              setLinkGenerated(false);
              setValsFromSearch(val);
              setFieldTouched('dataSelectedStations')

              if(val!== null && typeof val!=='undefined'){
                const isolateIdsArray =val.map(value=> value.station_id);
                if(typeof isolateIdsArray[0]==='undefined'){
                  isolateIdsArray.splice(0,1);
                }
                setFieldValue('dataSelectedStations', isolateIdsArray.join(','));
                setCurrSelectedStations(val);
              }
            };

            const searchSites=(e:React.SyntheticEvent<Element, Event>, val: any)=>{
              setLinkGenerated(false)
              if(Number(val[val.length-1]?.site_id)!==-1){
                const selectAllAlreadySelected = sitesSearched?.find(item=>Number(item?.site_id)===-1)
                const selectedAllInValues = val?.find(item=>Number(item.site_id)===-1);
                if(!selectedAllInValues && selectAllAlreadySelected){
                  setSitesSearched([]);
                  setFieldValue('sites','');
                  setFieldValue('fuels','')
                  setCurrSites([]);
                  setSelectedAll(false)
                }
                else{
                  const siteKeyArray = val.map(site=>site.uniqueKey)
                  setSitesSearched(val);
                  if(val!== null && typeof val!=='undefined'){
                    
                    const tempSites = allSites?.map((option, index) => ({
                      ...option, 
                      uniqueKey: `${option.site_key}-${index}`
                    }))
                    const findValue = tempSites.filter(item => siteKeyArray.includes(item.uniqueKey));
                    const isolateIdsArray =findValue.map(value=> value.site_id);
                    setFieldValue('sites', isolateIdsArray.join(','));
                    setCurrSites(findValue);
                  }
                }
              }
              else{
                const removeSelectAllOpt = sitesFiltered.slice(1, sitesFiltered.length)
                if(allSites.length===sitesFiltered.length){
                  if(sitesSearched[0]?.site_id===-1){
                    setSelectedAll(false)
                    setSitesSearched([]);
                    setCurrSites([]);
                    setFieldValue('sites','');
                    setFieldValue('fuels','')

                  }else{
                    setSitesSearched(sitesFiltered);
                    setSelectedAll(true)
                    const siteIds = removeSelectAllOpt.map(site=>site.site_id);
                    setFieldValue('sites', siteIds.join(','));
                    setCurrSites(sitesFiltered);
                  }
                }
                else{
                  setSitesSearched(removeSelectAllOpt);
                  setSelectedAll(false)
                  const siteIds = removeSelectAllOpt.map(site=>site.site_id);
                  setFieldValue('sites', siteIds.join(','));
                  setCurrSites(removeSelectAllOpt);

                }
              }
            };

            const handleDelete=(station_id:string)=>{
              setLinkGenerated(false);
              let temp2 = currSelectedStations.filter(item =>Number( item.station_id) !== Number(station_id));
              const isolateIdsArray =temp2.map(value=> value.station_id);
              setValsFromSearch(temp2);
              setCurrSelectedStations(temp2);
              setFieldTouched('dataSelectedStations');
              setFieldValue('dataSelectedStations', isolateIdsArray.join(','));
            }

            const deleteSite=(site_id:string)=>{
              setLinkGenerated(false);
              let temp2 = sitesSearched?.filter(item =>Number( item.site_id) !== Number(site_id));
              const isolateIdsArray =temp2.map(value=> value.site_id);
              setSitesSearched(temp2);
              setCurrSites(temp2);
              setFieldTouched('sites');
              setFieldValue('sites', isolateIdsArray.join(','));
            }

            const generateLink = () => { 
              const externalClim = `${process.env.REACT_APP_API}`.replaceAll('climatology', 'ext-climatology')
              if(values.dataSubject==='siteMetadata') {
                const fuelDownloadURL = globalThis.location.host.includes('localhost') ? 
                  `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`.split('apis/graphql', 1)[0].concat('siteMetadataDownload/download?') :
                  `${process.env.REACT_APP_GRAPHQL_URL}`.split('api/climatology/graphql', 1)[0].concat('fuelmodel/siteMetadataDownload/download?');
              
                const siteIds = selectedAll ? `` : `siteIds=${sitesSearched.map(site => site.site_id).join(',')}`;
    
                const url =  `${fuelDownloadURL}${siteIds}`;        
                const shortenedURL = selectedAll ? fuelDownloadURL.concat('Site_Metadata.csv') : fuelDownloadURL.concat('.../Site_Metadata.csv');
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
              } else if (values.dataSubject==='fieldSample') {
                const start = moment.utc(values.startDate + ' ' + values.startHour + ":00:00").toISOString();
                const end = moment.utc(values.endDate + ' ' + values.endHour+":00:00").toISOString();
                const fuelDownloadURL = globalThis.location.host.includes('localhost') ? 
                  `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`.split('apis/graphql', 1)[0].concat('fuelmodel/sample/download?') :
                  `${process.env.REACT_APP_GRAPHQL_URL}`.split('api/climatology/graphql', 1)[0].concat('fuelmodel/sample/download?');
                  
                const siteIds = selectedAll ? 'All' : sitesSearched.map(site => site.site_id).join(',');
                const status = includeArchivedSamples ? 'All' : 'Submitted';
                const fuelIdList:any = [];
                downloadFuelTypes?.forEach(fuelType => {
                  fuelIdList.push(fuelType.fuel_id);
                });
    
                const url =  `${fuelDownloadURL}returnAll=${values.returnAll}&responseFormat=csv&siteId=${siteIds}&sampleId=&startDate=${start}&endDate=${end}&filterByFuelId=${fuelIdList.join(',')}&filterByStatus=${status}&filterByCategory=${downloadCategory}&filterBySubCategory=${downloadSubCategory}&filterByMethod=${downloadMethod}&sortBy=${values.orderBy}&sortOrder=${values.order}`;
                const shortenedURL = fuelDownloadURL.concat('.../fieldSample.csv');
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
              } else if (values.dataSubject==='weather' && values.dataTimeIncrements==='daily') {
                const wxDailyURL = `${externalClim}/download-wx-daily-summary/?`;
                const dataset = values.dataSet ==='observationforecast'? 'all': values.dataSet;
                const url = presetSelected
                ? `${externalClim}/download-wx-daily-summary/?stationIds=${values.dataSelectedStations}&presetDate=-5Days7Days&dataset=${dataset}&dataFormat=${values.dataFormat}` 
                : `${externalClim}/download-wx-daily-summary/?stationIds=${values.dataSelectedStations}&startDate=${values.startDate}&endDate=${values.endDate}&dataset=${dataset}&dataFormat=${values.dataFormat}`;
                let shortenedURL=wxDailyURL.concat(`.../wxDailySummary.${values.dataFormat}`);
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
              } else if((values.dataSubject==='weather' || values.dataSubject === 'FireDanger') && values.dataTimeIncrements==='hourly'){
                const start = moment.utc(values.startDate +' ' +values.startHour+":00:00");
                const end = moment.utc(values.endDate +' ' +values.endHour+":00:00");
                const wxHourlyURL = `${externalClim}/download-weather?`;
                let nfdrURL = `${externalClim}/download-nfdr?`;
                const valuesFuelModels = values.fuelModels === 'V,W,X,Y,Z' ? '' : `&fuelModels=${values.fuelModels}`;
                const dataset = values.dataSet === 'observationforecast' ? 'all' : values.dataSet;
                const tz = values.timeZoneType === 'utc' ? 'UTC' : 'LocalStationTime';

                const url = presetSelected
                  ? (
                    values.dataSubject === 'weather'
                      ? `${externalClim}/download-weather?stationIds=${values.dataSelectedStations}&presetDate=-5Days7Days&dataset=${dataset}&dataFormat=${values.dataFormat}&dataIncrement=${values.dataTimeIncrements}`
                      : `${externalClim}/download-nfdr?stationIds=${values.dataSelectedStations}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}&dataset=${dataset}${valuesFuelModels}&dateTimeFormat=${tz}`
                  )
                  : (
                    values.dataSubject === 'weather'
                      ? `${externalClim}/download-weather?stationIds=${values.dataSelectedStations}&startDate=${moment.utc(start.valueOf() - 30 * ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]')}&endDate=${moment.utc(end.valueOf() + (30 * ONEMIN) - ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]')}&dataset=${dataset}&dataFormat=${values.dataFormat}&dataIncrement=${values.dataTimeIncrements}`
                      : `${externalClim}/download-nfdr?stationIds=${values.dataSelectedStations}&endDate=${moment.utc(end.valueOf() + (30 * ONEMIN) - ONESEC).format('YYYY-MM-DDTHH:mm:ss[Z]')}&startDate=${moment.utc(start.valueOf() - 30 * ONEMIN).format('YYYY-MM-DDTHH:mm:ss[Z]')}&dataFormat=${values.dataFormat}&dataset=${dataset}${valuesFuelModels}&dateTimeFormat=${tz}`
                  );

                let shortenedURL='';
                if(values.dataSubject==='weather' && !values.dataSelectedStations.includes(',')){
                  shortenedURL = wxHourlyURL.concat(`.../wxHourlySummary.${values.dataFormat}`)
                }
                else if(values.dataSubject==='weather' && values.dataSelectedStations.includes(',') && values.dataFormat==='fw21'){
                  shortenedURL = wxHourlyURL.concat(`.../wxHourlySummary.zip`)
                }
                else if(values.dataSubject==='weather' && values.dataSelectedStations.includes(',') && values.dataFormat==='csv'){
                  shortenedURL = wxHourlyURL.concat(`.../wxHourlySummary.csv`)
                }
                else{
                  shortenedURL = nfdrURL.concat(`.../nfdrsHourlySummary.${values.dataFormat}`)
                }
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
            } else if (values.dataSubject === 'FireDanger' && values.dataTimeIncrements === 'daily') {
              if (values.averageFireDanger) {
                const start = moment.utc(values.startDate + ' ' + values.startHour + ":00:00");
                const end = moment.utc(values.endDate + ' ' + values.endHour + ":00:00");
                let nfdrURL = `${externalClim}/download-nfdr-daily-avg/?`;
                const valuesFuelModels = values.fuelModels === 'V,W,X,Y,Z' ? '' : `&fuelModels=${values.fuelModels}`;
                const dataset = values.dataSet === 'observationforecast' ? 'all' : values.dataSet;
                const url = presetSelected
                  ? `${externalClim}/download-nfdr-daily-avg/?dataset=${dataset}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`
                  : `${externalClim}/download-nfdr-daily-avg/?dataset=${dataset}&startDate=${moment.utc(start.valueOf() - 30 * ONEMIN).format('YYYY-MM-DD')}&endDate=${moment.utc(end.valueOf() + (30 * ONEMIN) - ONESEC).format('YYYY-MM-DD')}&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`;

                let shortenedURL = nfdrURL.concat(`.../nfdrsDailyAvg.${values.dataFormat}`);
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
              } else {
                const start = moment.utc(values.startDate + ' ' + values.startHour + ":00:00");
                const end = moment.utc(values.endDate + ' ' + values.endHour + ":00:00");
                let nfdrURL = `${externalClim}/download-nfdr-daily-summary/?`;
                const valuesFuelModels = values.fuelModels === 'V,W,X,Y,Z' ? '' : `&fuelModels=${values.fuelModels}`;
                const dataset = values.dataSet === 'observationforecast' ? 'all' : values.dataSet;
                const url = presetSelected
                  ? `${externalClim}/download-nfdr-daily-summary/?dataset=${dataset}&presetDate=-5Days7Days&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`
                  : `${externalClim}/download-nfdr-daily-summary/?dataset=${dataset}&startDate=${moment.utc(start.valueOf() - 30 * ONEMIN).format('YYYY-MM-DD')}&endDate=${moment.utc(end.valueOf() + (30 * ONEMIN) - ONESEC).format('YYYY-MM-DD')}&dataFormat=${values.dataFormat}&stationIds=${values.dataSelectedStations}${valuesFuelModels}`;

                let shortenedURL = nfdrURL.concat(`.../nfdrsDailySummary.${values.dataFormat}`);
                navigator.clipboard.writeText(url);
                setShortURL(shortenedURL);
                setLongURL(url);
                setLinkGenerated(true);
              }
            }
          }

            const paramsForWeather={
              noRestrictedStations: noRestrictedStations,
              stationsForSearch: stationsForSearch,

              handleBlur: handleBlur,
              setDataSet: setDataSet,
              setDataFormat: setDataFormat,
              setDataIncrements:setDataIncrements,
              handleClickHour: handleClickHour,
              startHrClicked: startHrClicked,
              setStartHour: setStartHour,
              handleEndHourClicked: handleEndHourClicked,
              endHrClicked: endHrClicked,
              setEndHour: setEndHour,
              handleSearch: handleSearch,
              valsFromSearch: valsFromSearch,
              currSelectedStations: currSelectedStations,
              handleDelete: handleDelete,
              clearSelected: clearSelected,
              setFieldValue:setFieldValue,
              handleCloseMaxFileSize: handleCloseMaxFileSize,
              openMaxFileSize: openMaxFileSize,
              errorDate: errorDate,
              setErrorDate: setErrorDate,
              setLinkGenerated: setLinkGenerated,
              onPresetSelected: handlePresetSelected, 
              today: today,
            }
            const paramsForStationInfo ={
              noRestrictedStations: noRestrictedStations,
              stationsForSearch: stationsForSearch,

              values: values,
              errors: errors,
              touched: touched,
              setDataFormat: setDataFormat,
              setFieldTouched: setFieldTouched,
              handleSearch: handleSearch,
              valsFromSearch: valsFromSearch,
              handleDelete: handleDelete,
              currSelectedStations: currSelectedStations,
              clearSelected: clearSelected
            }
            const paramsForFieldSample ={
              setDownloadFuelTypes: setDownloadFuelTypes,
              setDownloadCategory: setDownloadCategory,
              setDownloadSubCategory: setDownloadSubCategory,
              setDownloadMethod: setDownloadMethod,
              setLinkGenerated: setLinkGenerated,
              setFieldSampleHasRows: setFieldSampleHasRows,
              includeArchivedSamples: includeArchivedSamples,
              token: token
            }
            const paramsForSiteMetadata = {
              allSites: allSites,
              selectedAll: selectedAll,
              valsFromSearch: valsFromSearch,
              currSites: currSites,
              sitesFiltered: sitesFiltered,
              setSitesFiltered: setSitesFiltered,
              setSelectedAll: setSelectedAll,
              searchSites: searchSites,
              handleSearch: handleSearch,
              handleDelete: handleDelete,
              clearSites: clearSites,
              clearSelected: clearSelected,
              deleteSite: deleteSite,
              sitesSearched:sitesSearched,
            }
            const paramsForFireDanger={
              noRestrictedStations: noRestrictedStations,
              stationsForSearch: stationsForSearch,

              handleBlur: handleBlur,
              setDataSet: setDataSet,
              setErrorDate: setErrorDate,
              setDataFormat: setDataFormat,
              setDataIncrements:setDataIncrements,
              handleClickHour: handleClickHour,
              startHrClicked: startHrClicked,
              setStartHour: setStartHour,
              handleEndHourClicked: handleEndHourClicked,
              endHrClicked: endHrClicked,
              setEndHour: setEndHour,
              handleSearch: handleSearch,
              valsFromSearch: valsFromSearch,
              currSelectedStations: currSelectedStations,
              handleDelete: handleDelete,
              clearSelected: clearSelected,
              setFieldValue:setFieldValue,
              handleCloseMaxFileSize: handleCloseMaxFileSize,
              openMaxFileSize: openMaxFileSize,
              errorDate: errorDate,
              fuelModels: fuelModels,
              setFuelModels: setFuelModels,
              handleFuelModels: handleFuelModels,
              deleteFuelModels: deleteFuelModels,
              setLinkGenerated: setLinkGenerated,
              onPresetSelected: handlePresetSelected,
              today: today,
            }
            /* this will handle check in date*/
            const handleStartDate = (newValue: any)=>{
              if( !isValidDate(newValue) ){
                setErrorStartDate('Invalid Date');
                return;
              }
              setStartDate(moment(newValue).utc().toDate());
              if((moment(newValue) <= moment(endDate))){
                if(errorEndDate=== 'Invalid Date' || newValue=== 'Invalid Date'){
                  setErrorStartDate('Invalid Date');
                }
                
                else{
                  setErrorEndDate(null)
                  setErrorStartDate(null)
                }
              }
              else if(moment(newValue) > moment(endDate)) {
                setErrorStartDate('Start Date is after End Date');
              }
              else{
                setErrorStartDate('Invalid Date');
              }
            }
            
            /* this will handle check out date changed*/
            const handleEndDate = (newValue: any)=>{
              if( !isValidDate(newValue) ){
                setErrorEndDate('Invalid Date');
                return;
              }
              setEndDate(moment(newValue).utc().toDate());
              if((moment(newValue) >= moment(startDate))){
                if(errorStartDate=== 'Invalid Date' || newValue=== 'Invalid Date'){
                  setErrorDate('Invalid Date')
                }
                else{
                  setErrorEndDate(null)
                  setErrorStartDate(null)
                }
              }
              else if(moment(newValue) < moment(startDate)){
                setErrorEndDate('End Date is before Start Date');
              }
              else{
                setErrorEndDate('Invalid Date');
              }
            }
          return(
            <Form onSubmit={handleSubmit}>
            <Grid row desktop={{col: 6}}>
              <label id='dataSubject'>Data Subject Area <span className='required'>Required</span>
              <Select
                displayEmpty
                renderValue={values.dataSubject !== "" ? undefined : () => "Select a Subject Area"}
                labelId='dataSubject'
                onBlur={handleBlur}
                error={!!errors.dataSubject && !!touched.dataSubject}
                name="dataSubject"
                onChange={e=>{setDataSubject(e)}}
                label="Select a Subject Area"
                value={values.dataSubject}
                className= "select-styles dataDownload"
                placeholder='Select a Subject Area'
                id="dataSubject"

              >
                <MenuItem value="weather" key="weather">Weather</MenuItem>
                <MenuItem value="stationMetadata" key="stationMetadata">Weather Station Metadata</MenuItem>

                <MenuItem value="fieldSample" key="fieldSample">Field Sample</MenuItem>
                <MenuItem value="siteMetadata" key="siteMetadata">Field Sample Site Metadata</MenuItem>
                <MenuItem value="FireDanger" key="FireDanger">Fire Danger</MenuItem>
              </Select>
              </label>
              <span  style={{color: '#d32f2f'}}>{errors.dataSubject && touched.dataSubject && errors.dataSubject}</span>
            </Grid>
            {/*STATION INFORMATION  to Display Station Info form*/}
            {values.dataSubject==='stationMetadata' && <StationInformation key={autocompleteKey} stationInfoParams={paramsForStationInfo} clearSelected={clearSelected}/>}
            {/*WEATHER COMPONENT TO DISPLAY WEATHER FORM*/}
            {values.dataSubject ==='weather' && <Weather key={autocompleteKey} weatherDLParams={paramsForWeather} clearSelected={clearSelected} onPresetSelected={handlePresetSelected} />}
            {/*FireDanger COMPONENT TO DISPLAY Fire Danger FORM*/}
            {values.dataSubject ==='FireDanger' && <FireDanger key={autocompleteKey} fireDangerDLParams={paramsForFireDanger} clearSelected={clearSelected} onPresetSelected={handlePresetSelected} />}
            {/*SITE METADATA  to Display Site Info form*/}
            {(values.dataSubject==='siteMetadata') && <SiteMetadata siteMetadataParams={paramsForSiteMetadata}/>}
            {/*FIELD SAMPLE to display field sample form*/}
            {values.dataSubject==='fieldSample' && <div>            
              <Grid row desktop={{ col: 6 }}>
                    <label>Search 
                        <Tooltip title={"Type in one of the following attributes to populate the search results. List of attributes: -Agency Landowner -State Name -Area Name -Area ID -Group Name -Site Name"} placement="top-start">
                            <InfoIcon style={{fontSize: 'medium'}}/>
                        </Tooltip>
                        <span className='required'>Required</span>
                        <div className='searchStationsDownloadPage'>
                            <i className="fas fa-search" />
                            <ScrollCtx.Provider value ={{scrollTopRef, restoreToken}}>
                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                noOptionsText={
                                    <div className='no-results'>
                                        <div>No results match your search criteria.</div>
                                        <div><b>Here are a few tips:</b></div>
                                        <div>• Remember to check your spelling<br />
                                            • Ensure you are searching Site Name<br/>
                                            • Ensure you are searching Group Name<br/>
                                            • Ensure you are searching Area Name<br/>
                                            </div>
                                    </div>
                                }
                                onChange={(e, value) => {searchSites(e, value);setRestoreToken((t)=> t+1);}}
                                value={sitesSearched}
                                getOptionKey={(option)=>option.uniqueKey}
                                isOptionEqualToValue={(option,value)=>option.site_key===value.site_key}
                                options={(allSites?.map((option, index) => ({
                                    ...option, 
                                    uniqueKey: `${option.site_key}-${index}`,
                                    label: `${option.site_key}`
                                }))) }                               
                                renderOption={
                                    (props, option)=>(
                                    <li {...props} key={option.uniqueKey} value={option} id={option}>
                                        {option.display_key}
                                    </li>
                                )}
                                ListboxComponent={VirtualizedListBoxSite}         
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
                                        className="dataDownload"
                                        placeholder='Search All Sites...'
                                        onInput={
                                            (e) => {validateCharacters(e, ValidCharacters.TextField)}
                                        }
                                        aria-label={'Search Sites by Site Name-Group Name-Area Name'}
                                        data-testid={'search-bar'}
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            type: 'search',
                                        }}
                                        FormHelperTextProps={{
                                            tabIndex:0
                                        }}
                                        onBlur={()=>setFieldTouched('sites')}
                                        error={!!touched.sites && !!errors.sites}
                                    />
                                )}
                            />
                            </ScrollCtx.Provider>
                        </div>
                        <span style={{color: '#d32f2f'}}>{errors.sites && touched.sites && errors.sites}</span>
                                
                    </label>
                    {
                      
                      selectedAll ? (
                        <div className='selectedStations' style={{paddingTop: '5px', paddingBottom: '5px', fontSize: 'italics'}}>
                            <div> {`All sites have been selected. Total sites selected: ${allSites.length-1}`}</div>
                            <div><button type='button' onClick={clearSites}>Clear All</button></div>

                        </div>
                        ): (
                          <div className={values.sites ? 'selectedStations' : 'hideRow'}>
                          <div>{`These are your selected sites. Total sites selected: ${currSites.length}`}</div>
                          <div className="smooth-scrollbar" style={{maxHeight: '400px', border: '1px solid #717171', width: '75vw',padding: '3px', borderRadius:'5px'}}>
                              {
                                  currSites.map((site) =>
                                      <Chip label={`${site.display_key}`}
                                          key={site.site_key} 
                                          onDelete={() => deleteSite(site.site_id)} 
                                          variant="outlined" 
                                          onKeyDown={(event)=>{event.key==='Backspace'&& deleteSite(site.site_id)}}
                                          deleteIcon={<CloseIcon tabIndex={0} onKeyDown={(event) => { event.key==='Enter' && deleteSite(site.site_id)}}/>} 
                                      />
                                  )
      
                              }
                          </div>
                          <div><button type='button' onClick={clearSites}>Clear All</button></div>
                      </div>
                        )
                    }
                </Grid>
                <Grid row className={values.dataSubject!==('fieldSample') ? 'hideRow' : ''} desktop={{ col: 8 }}>
                  <div><span className='font-sans-md text-bold'>Date Range</span><span className='required1'>Required</span>
                  <div className={`date-range-picker-wrapper ${errorDate? 'error':''}`} style={{ margin: '10px 0' }}>
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      slotProps={{
                          textField: {
                          error: errorStartDate ? true : false,
                          helperText: errorStartDate,
                          id: 'uploadStartDate',
                          },

                      }}
                      onError={(reason) => {
                        if (reason === 'disableFuture') {
                          setErrorStartDate('Start Date is in the Future');
                        }
                        else if (reason === 'invalidDate') {
                          setErrorStartDate('Invalid Date');
                        }
                        else if (reason === null && moment(startDate) <= moment(endDate)) {
                          setErrorStartDate(null);
                          setErrorEndDate(null);
                        }
                        else if (moment(startDate) > moment(endDate)) {
                          setErrorStartDate('Start Date is after End Date');
                        }
                        else {
                          setErrorStartDate('An Error on Start Date')
                        }
                      }}
                      onChange={(newValue) => { 
                        setFieldValue('startDate',moment(newValue).format("YYYY-MM-DD"));
                        handleStartDate(newValue);
                      }}
                    />
                    <span style={{ margin: '0 10px' }}></span>
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      aria-labelledby='uploadEndDate'

                      onError={(reason) => {
                          if (reason === 'disableFuture') {
                          setErrorEndDate('End Date is in the Future');
                          }
                          else if (reason === 'invalidDate') {
                          setErrorEndDate('Invalid Date');
                          }
                          else if (reason === null && moment(startDate) <= moment(endDate)) {
                          setErrorStartDate(null);
                          setErrorEndDate(null);
                          }
                          else if (moment(startDate) > moment(endDate)) {
                          setErrorEndDate('End Date is before End Date');
                          }
                          else {
                          setErrorStartDate('An Error on Start Date')
                          }
                      }}
                      slotProps={{
                          textField: {
                          error: errorEndDate ? true : false,
                          helperText: errorEndDate,
                          id: 'uploadEndDate',

                          },
                      }}
                      onChange={(newValue) => {
                          setFieldValue('endDate',moment(newValue).format("YYYY-MM-DD"))
                          handleEndDate(newValue);
                      }}
                    />
                  </div>
                  </div>
                </Grid>
                <span style={{color: '#d32f2f'}}>{errorDate}</span>

                {values.sites && values.startDate && values.endDate &&
                <div>
                    <GridContainer>
                      <Grid row gap='md'>
                        <Grid desktop={{ col:'auto'}}><div className='font-sans-lg text-bold'>Select Fuel(s)</div></Grid>
                        {state.user && (fieldSampleAreaEditor(state.user)) &&
                          <Grid desktop={{ col:8 }}>
                          <div className='font-sans-md text-bold' style={{width: '50%'}}>
                            <FormControlLabel
                              value="top"
                              control={<Switch 
                                onChange={(event, newValue)=>{
                                  setIncludeArchivedSamples(newValue);
                                  setLinkGenerated(false);
                                }}
                                aria-label='Include Archived Samples?'
                              />}
                              label="Include Archived Samples?"
                              labelPlacement="top"/>
                            
                          </div>
                          </Grid>
                        }
                      </Grid>
                    </GridContainer>
                    <Suspense fallback={<LoadingSpinner/>}>
                      <Browse fieldSampleParams={paramsForFieldSample} 
                        setDownloadFuelTypes={setDownloadFuelTypes} 
                        setDownloadCategory={setDownloadCategory} 
                        setDownloadSubCategory={setDownloadSubCategory} 
                        setDownloadMethod={setDownloadMethod}
                        setFieldSampleHasRows={setFieldSampleHasRows}
                        setLinkGenerated={setLinkGenerated}
                      />
                    </Suspense>
                </div>
                }

            </div>
          }
            <Grid row style={{marginTop:'3%', paddingBottom: '1rem'}} gap="md">
              <div>
                <Button variant="contained" 
                  type="submit" 
                  aria-disabled={!isValid || 
                    errorDate.length>0 || 
                    (values.dataSubject==='fieldSample' && fieldSampleHasRows===false) ||
                    (values.dataSubject==='siteMetadata' && currSites.length===0)
                    || noDownloadCheck(values, !values.dataTimeIncrements.includes('daily')?'hourly': 'daily')
                  }>
                  Download Data
                </Button>
              </div>
              {
                (values.dataSubject==='fieldSample' || values.dataSubject==='siteMetadata' || values.dataSubject==='weather' || values.dataSubject==='FireDanger') && linkGenerated === false &&
                <div>
                  <Button variant="outlined" 
                    type="submit" 
                    onClick={generateLink} 
                    aria-disabled={
                      (checkQueueTrigger(values, !values.dataTimeIncrements.includes('daily')?'hourly': 'daily'))
                      || !isValid || 
                      errorDate.length>0 || 
                      (values.dataSubject==='fieldSample' && fieldSampleHasRows===false) ||
                      (values.dataSubject==='siteMetadata' && currSites.length===0) ||
                      (values.dataSubject==='FireDanger' && values.timeZoneType==='lst' && values.dataTimeIncrements==='hourly' )
                      || noDownloadCheck(values, !values.dataTimeIncrements.includes('daily')?'hourly': 'daily')
                    }
                      >
                    Copy Data Link
                  </Button>
                </div>
              }
              {
                (values.dataSubject==='fieldSample' || values.dataSubject==='siteMetadata'|| values.dataSubject==='weather' || values.dataSubject==='FireDanger') && linkGenerated === true && 
                <div>
                  <Grid>
                    <CheckIcon/>
                    <span>Copied</span>
                  </Grid>
                  <Grid>
                    <a href={longURL}>{shortURL}</a>
                  </Grid>
                </div>
              }
              
            </Grid>
            </Form>
        )}}
      </Formik>
      <Modal
        open={openMaxFileSize}
        onClose={handleCloseMaxFileSize}
      >
        <Box>
          <Typography id="modal-modal-title" className='modalTitle' variant="h6" component="h2">
            Download Queued <i className="fas fa-times fa-lg" onClick={handleCloseMaxFileSize} onKeyDown={handleCloseMaxFileSize} role='none'/>
          </Typography>
          <Typography id="modal-modal-description" className='modalDescription' sx={{ mt: 2 }}>
            Due to the size of your data request, your downloads will be queued. To retrieve your file, navigate to <a href={'download'+ROUTE_PATHS.queued_download}>Queued Downloads</a>, or click the Queued Download tab at the top of the Download page.
          </Typography>
        </Box>
      </Modal>
    </GridContainer>
  )
}